module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/artillery-battalion-lvl1-50.555c26f0.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/artillery-battalion-lvl1-50.png
// module id = 3497
// module chunks = 11